import React from "react";

const Card = ({ number, title, description, iconClass }) => {
  return (
    <div className="relative bg-[#ffffff] rounded-3xl shadow-lg w-[356px] h-[296px] p-6 flex flex-col items-start overflow-hidden">
      {/* Background Shape 1 */}
      <div className="absolute w-[237px] h-[237px] bg-[#f4efea] bg-cover bg-center rounded-full -top-8 -left-4 z-0"></div>
      <div className="absolute w-[237px] h-[237px] bg-[#f4efea] bg-cover bg-center rounded-full left-[203px] top-[156px] z-0"></div>

      {/* Number Frame */}
      <div className="absolute w-[103px] h-[103px] bg-[#ffffff] rounded-full flex items-center justify-center -top-2 -left-3 z-10 text-[#212529]">
        <span className="text-[80px] font-roboto leading-tight">{number}</span>
      </div>

      {/* Icon */}
      <div
        className={`absolute ${iconClass} bg-no-repeat bg-center bg-contain z-10`}
        style={{
          width: "80px",
          height: "80px",
          top: "6%",
          left: "75%",
        }}
      ></div>

      {/* Text Content */}
      <div className="z-20 w-[210px] h-[53px] ml-[6px] mt-10 leading-5 text-[#212529]">
        <h3 className="text-[18px] font-roboto mt-10 z-20">{title}</h3>
      </div>
      <div className="z-20 w-[289px] h-[113px] text-[#212529]">
        <p className="text-md font-poppins italic mt-12 mb-2 ml-[6px] z-20">
          {description}
        </p>
      </div>
    </div>
  );
};

export default Card;
